import {
  paisActual,
  MPC,
  MCA,
  CR
} from '@/utils/constants';
import getUrlParams from '@/utils/getUrlParams';

const getIsStage = () => {
  const isStage = process.env.NODE_ENV === 'staging';
  const isDev = process.env.NODE_ENV === 'development';
  const forceStage = false;

  return (forceStage && isDev) || isStage;
};

export const getCurrentCountry = () => {
  const isStage = getIsStage();

  const subdomain = window.location.hostname.substring(
    0,
    window.location.hostname.indexOf('.')
  );

  const currentCountry = isStage ? subdomain.replace('pagos', '') : subdomain;

  if (!currentCountry) {
    return paisActual;
  }

  return currentCountry.toUpperCase();
};

export const getApp = () => {
  const isMCA = window.location.href.includes('mispagosclaro')
    || window.location.href.includes('claropayment')
    || getUrlParams('app')?.toLowerCase() === 'mca';

  return isMCA ? MCA : MPC;
};

export const currentCountry = getCurrentCountry();
export const app = getApp();
export const getApiUrl = () => {
  const isStage = getIsStage();
  const country = currentCountry;

  if (isStage) {
    return `https://${country?.toLowerCase()}.portal-universal.com`;
  }

  const urlEnd = `${country !== CR ? '.com' : ''}.${country?.toLowerCase()}`;
  return `https://paquetes.miclaro${urlEnd}`;
};

